<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SectionHeader" });
import Icon from "../../elements/icon/Icon.svelte";
export let label;
export let isVisible = true;
const onClick = () => {
    isVisible = !isVisible;
};
const onKeypress = (event) => {
    if (event.key === "Enter") {
        isVisible = !isVisible;
    }
};
</script>

<div class = 's8-section-header' role = 'button' tabindex = '0'
    on:click = { onClick }
    on:keypress = { onKeypress }
>
    <span class = 's8-section-label'>{ label }</span>
    <div class = 's8-section-line' />
    <Icon key = { isVisible ? 'chevronUp' : 'chevronDown' } />
</div>


<style>

    div.s8-section-header {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
                user-select: none;
        margin-bottom: 12px;
    }

        div.s8-section-header span.s8-section-label {
            font-weight: 600;
            white-space: nowrap;
        }

        div.s8-section-header div.s8-section-line {
            flex: 1;
            height: 1px;
            background-color: rgba(39, 39, 17, 0.16);
        }</style>